import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './About.css'

import Text from '../components/Text'
import Footer from '../components/Footer'

class About extends Component {
  componentWillMount () {
    return this.props.changeHeaderColors('#101110', '#fffbda')
  }

  render () {
    return (
      <div className='content columns'>
        <div className='sidebar'>
          <div className='sidebarContent' style={{ borderRight: `0.2rem solid #101110` }}>
            <div className='backHome'>
              <Link to='/'>
                <div>
                  <div>
                    Back
                    <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='42.666px' height='15.87px' viewBox='0 0 42.666 15.87' enableBackground='new 0 0 42.666 15.87' space='preserve'>
                      <polygon fill='#101110' points='0,7.935 7.934,0 10.178,0 3.037,7.142 11.869,7.142 42.666,7.142 42.666,8.729 11.869,8.729 3.037,8.729 10.178,15.87 7.934,15.87' />
                    </svg>
                  </div>
                  <div>Home</div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className='column about'>
          <div className='title'>ABOUT</div>
          <hr />
          <Text>
            <img alt='cliparts' src='cliparts/cliparts-01-black.svg' /> MY NAME IS ERWAN COUTELLIER <img alt='cliparts' src='cliparts/cliparts-23.svg' /> AND I’M A FRENCH GRAPHIC DESIGNER AND ART DIRECTOR BORN IN <img alt='cliparts' src='cliparts/cliparts-24.svg' /> 1990. I’M CURRENTLY BASED IN <img alt='cliparts' src='cliparts/cliparts-25.svg' /> PARIS.
          </Text>
          <hr />
          <Text>
            I’M WORKING <img alt='cliparts' src='cliparts/cliparts-26.svg' /> ON VISUAL IDENTITIES, PRINTED <img alt='cliparts' src='cliparts/cliparts-27.svg' /> MATTER, EDITORIAL <img alt='cliparts' src='cliparts/cliparts-28.svg' /> AND WEB DESIGN, ILLUSTRATION AND ANIMATION. I HAVE BEEN WORKING IN DIFFERENT FIELDS: <img alt='cliparts' src='cliparts/cliparts-29.svg' /> EVENTS, CULTURE, <img alt='cliparts' src='cliparts/cliparts-30.svg' /> ARTS, COMMERCE, <img alt='cliparts' src='cliparts/cliparts-31.svg' />FASHION, ETC...
          </Text>
          <hr />
          <Text>
            IF YOU ARE INTERESTED IN MY WORK, DON’T HESITATE TO <img alt='cliparts' src='cliparts/cliparts-32.svg' /> GET IN TOUCH WITH ME REGARDING ANY INQUIRIES <img alt='cliparts' src='cliparts/cliparts-33.svg' /> OR FUTURE <img alt='cliparts' src='cliparts/cliparts-34.svg' /> COLLABORATION.
            I CAN HELP <img alt='cliparts' src='cliparts/cliparts-35.svg' /> YOU TO FIND GOOD SOLUTIONS <img alt='cliparts' src='cliparts/cliparts-36.svg' /> TO CARRY OUT <img alt='cliparts' src='cliparts/cliparts-37.svg' /> YOUR PROJECTS IN A CREATIVE WAY! <img alt='cliparts' src='cliparts/cliparts-38.svg' />
          </Text>
          <hr />
          <Footer>
            <div className='aboutTitle'>EXPERIENCE:</div>
            <div className='year'><span>2015-2017</span>: GRAPHIC DESIGNER FOR LESLIE DAVID - PARIS</div>
            <div className='year'><span>2012-2014</span>: GRAPHIC DESIGN FOR CONGRATS! MAGAZINE</div>
            <div className='year'><span>2014</span>: INTERNSHIP WITH CHLOÉ THOMAS - WIEN, AUSTRIA</div>
            <div className='year'><span>2013</span>: INTERNSHIP WITH BANK - BERLIN, GERMANY</div>
            <div className='year'><span>2012</span>: INTERNSHIP WITH ANTOINE ET MANUEL - PARIS</div>
            <div className='year'><span>2012</span>: INTERNSHIP WITH ICH ET KAR - PARIS</div>
            <div className='year'><span>2010</span>: INTERNSHIP WITH PARTI POÉTIQUE - SAINT-DENIS</div>
            <div className='aboutTitle'>EDUCATION:</div>
            <div className='year'><span>2015</span>: MASTER IN GRAPHIC DESIGN (DNSEP), HAUTE ÉCOLE DES ARTS DU RHIN (ARTS DÉCORATIFS DE STRASBOURG).</div>
            <div className='year'><span>2013</span>: BACHELOR IN GRAPHIC DESIGN (DNAP), HAUTE ÉCOLE DES ARTS DU RHIN (ARTS DÉCORATIFS DE STRASBOURG).</div>
            <div className='year'><span>2012</span>: BACHELOR IN DIGITAL GRAPHIC DESIGN (BTS OPTION MULTIMÉDIA),  ÉCOLE OLIVIER DE SERRES, PARIS.</div>
            <div className='year'><span>2011</span>: BACHELOR IN PRINTED GRAPHIC DESIGN (BTS OPTION GRAPHISME, ÉDITION, PUBLICITÉ),  ÉCOLE OLIVIER DE SERRES, PARIS.</div>
          </Footer>
        </div>
      </div>
    )
  }
}

export default About



// WEBPACK FOOTER //
// ./src/pages/About.js